import {defineAsyncComponent} from 'vue'

export default (app: any) => {
	app.component('reporting-res-controlling', defineAsyncComponent(() => import(/* webpackChunkName: "ResControlling" */ './Index.vue')))
	app.component('reporting-res-controlling-resdetail', defineAsyncComponent(() => import(/* webpackChunkName: "ResControllingResDetail" */ './ResControllingResDetail.vue')))
	app.component('reporting-excel-view', defineAsyncComponent(() => import(/* webpackChunkName: "ExcelView" */ './ExcelView.vue')))
	app.component('group-report-charts', defineAsyncComponent(() => import(/* webpackChunkName: "GroupReportCharts" */ './GroupReportCharts.vue')))
}
